export default __webpack_public_path__ + "static/media/29096 - RedBerry.aa1b0ff8.jpeg";